import { forwardRef, useEffect, useImperativeHandle, useRef, } from "react";
import Quill from 'quill';

const HtmlEditor = forwardRef(({ value = "", onChange, onBlur }, ref) => {
    const containerRef = useRef(null);
    const quillInstanceRef = useRef(null);
    const isUpdatingFromOutsideRef = useRef(false);

    useImperativeHandle(ref, () => ({
        getEditor: () => quillInstanceRef.current,
    }));

    useEffect(() => {
        if (!containerRef.current || quillInstanceRef.current) return;

        const quill = new Quill(containerRef.current, {
            theme: "snow",
            modules: {
                toolbar: [
                    [{ header: [1, 2, 3, false] }],
                    ["bold", "italic", "underline"],
                    [{ list: "ordered" }, { list: "bullet" }],
                    ["link"],
                    ["clean"],
                ],
            },
        });

        quillInstanceRef.current = quill;

        if (value) {
            quill.root.innerHTML = value;
        }

        quill.on("text-change", () => {
            if (isUpdatingFromOutsideRef.current) return;
            const html = quill.root.innerHTML;
            onChange?.(html === "<p><br></p>" ? "" : html);
        });

        quill.on("selection-change", (range) => {
            if (range === null) {
                onBlur?.();
            }
        });
    }, [onChange, onBlur, value]);

    useEffect(() => {
        const quill = quillInstanceRef.current;
        if (!quill) return;

        const currentHtml = quill.root.innerHTML;
        const nextHtml = value || "";

        if (currentHtml !== nextHtml) {
            isUpdatingFromOutsideRef.current = true;

            const selection = quill.getSelection();
            quill.root.innerHTML = nextHtml || "";

            if (selection) {
                try {
                    quill.setSelection(selection);
                } catch (e) { }
            }

            isUpdatingFromOutsideRef.current = false;
        }
    }, [value]);

    return <div ref={containerRef} />;
});

export default HtmlEditor;